'use strict';

class Klarna {
    // Save ScalaPay widget element, waits for script to be loaded
    loadWidget () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (response.data.product.price.sales) {
                var price = response.data.product.price.sales.value;
                var klarnaPlacement = document.getElementsByTagName('klarna-placement')[0];
                if (klarnaPlacement) {
                    klarnaPlacement.setAttribute('data-purchase-amount', Math.round(price * 100));
                    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
                }
            }
        });
    }

    // Load Klarna widget and analytics observer
    loadKlarnaWidgetAndObservers () {
        if ($('.page').data('action') === 'Product-Show' || $('.page').data('action') === 'Cart-Show') {
            var _self = this;
            _self.loadWidget();

            var checkWidget = setInterval(function () {
                let klarnaPayWidget = $('klarna-placement');

                if (klarnaPayWidget.length) {
                    clearInterval(checkWidget);
                    _self.prepareObservers();
                }
            }, 2000);
        }
    }

    // Observe analytics event
    prepareObservers () {
        if (!$('klarna-placement div').length) {
            return;
        }
        $($('klarna-placement div')[0].shadowRoot).find('button.link').on('click', function () {
            $('body').trigger('klarnaPay:openModal');
        });
    }
}

const klarna = new Klarna();
export default klarna;
